import { REFRESH_PARAMETERS } from "../constants/action-types/extras";


export const setRefreshParameters = (payload) => {
    return {
      type: REFRESH_PARAMETERS,
      payload: payload,
    };
  };